var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectRecipeShouldShowInputIcon } from "../../balancingSelectors/selectBalancingUiDefinitions";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { selectProductionResourceTotalBuffAmount, selectProductionXpBuffAmount, } from "../../selectors/selectBuffsInfo";
import { selectPlayerLevel } from "../../selectors/selectPlayerLevelInfo";
import { selectAllRecipeInfoByBuildingId, selectLastRecipeId, } from "../../selectors/selectRecipeInfo";
import { selectStorageInfo } from "../../selectors/selectStorageInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdEventSoundCore } from "../../utils/sound/IdEventSoundCore";
import { utilBuildings } from "../../utils/utilBuildings";
import { utilNumber } from "../../utils/utilNumber";
import { utilPager } from "../../utils/utilPager";
import { utilProduction } from "../../utils/utilProduction";
import { utilRecipes } from "../../utils/utilRecipes";
import { ButtonContextMenuStart } from "../generic/common/ButtonContextMenuStart";
import { ButtonPagerLeft } from "../generic/common/ButtonPagerLeft";
import { ButtonPagerRight } from "../generic/common/ButtonPagerRight";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { List } from "../generic/list/List";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { Pager } from "../generic/pager/Pager";
import { Slider } from "../generic/range-slider/Slider";
import { TextLoca } from "../generic/text/TextLoca";
import { actionProductionRecipeSelect, actionProductionStart, } from "../info/production/actionProductionInfo";
import { Recipe } from "../inventory/recipe/Recipe";
import { ResourceCost } from "../inventory/resource/ResourceCost";
import { ResourceProduct } from "../inventory/resource/ResourceProduct";
import { actionBuildingsDeselect } from "../player-base/buildings/actionBuildings";
import { XpResource } from "../xp/XpResource";
import { ProductionTime } from "./ProductionTime";
var ContextMenuStartProduction = /** @class */ (function (_super) {
    __extends(ContextMenuStartProduction, _super);
    function ContextMenuStartProduction() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            amount: -1,
        };
        _this.RecipesPerPage = 5;
        _this.GridColumnStartForProduct = 5;
        _this.GridColumnEndForCost = 3;
        _this.getTitle = function (recipe) {
            if (recipe == undefined) {
                return "";
            }
            if (recipe.product[0] == undefined) {
                return React.createElement(TextLoca, { id: IdLoca.exp });
            }
            var product = recipe.product[0];
            var amount = _this.getResourceAmountInInventory(product.id);
            var storageLimit = _this.props.maxStorage;
            if (product.storageLimit === -1) {
                return (React.createElement("span", null,
                    React.createElement(TextLoca, { id: product.locaKey }),
                    " (",
                    React.createElement(TextLoca, { id: IdLoca.inStorage }),
                    " ",
                    React.createElement(NumberFormat, { amount: amount }),
                    ")"));
            }
            else {
                return (React.createElement("span", null,
                    React.createElement(TextLoca, { id: product.locaKey }),
                    " (",
                    React.createElement(TextLoca, { id: IdLoca.inStorage }),
                    " ",
                    React.createElement(NumberFormat, { amount: amount }),
                    "/",
                    React.createElement(NumberFormat, { amount: storageLimit }),
                    ")"));
            }
        };
        _this.getPager = function (recipe) {
            var recipes = _this.filterFeasibleRecipes(_this.props.recipes || [], _this.props.resources);
            var pageCount = Math.ceil(recipes.length / _this.RecipesPerPage);
            var recipePosition = recipe
                ? recipes.findIndex(function (candidateRecipe) { return candidateRecipe.recipe.id === recipe.recipe.id; })
                : 0;
            var selectedPage = Math.floor(recipePosition / _this.RecipesPerPage);
            return (React.createElement(Pager, { pageCount: pageCount, page: selectedPage }, _this.renderPager));
        };
        _this.renderPager = function (page, changePage) {
            var recipes = _this.filterFeasibleRecipes(_this.props.recipes || [], _this.props.resources);
            var shouldDisplayInputIcon = selectRecipeShouldShowInputIcon(_this.props.building.balancing.id);
            var lastPage = Math.floor(recipes.length / (_this.RecipesPerPage + 1));
            var nextIndex = (page + 1) * _this.RecipesPerPage;
            var nextRecipe = recipes.length > nextIndex ? recipes[nextIndex] : undefined;
            var teasedRecipe = nextRecipe && (React.createElement("div", { className: "context-menu-fixed-teased-recipe" }, _this.renderPagerItem(nextRecipe, nextIndex, shouldDisplayInputIcon, function () {
                return changePage(page + 1);
            })));
            return (React.createElement("div", { className: "context-menu-fixed-pager-wrapper" },
                React.createElement("div", { className: "flex flex--guts context-menu-fixed-pager-arrow " + (page === 0 ? "disabled" : "") },
                    React.createElement(ButtonPagerLeft, { onClick: function () { return changePage(page - 1); }, disabled: page === 0 })),
                React.createElement(List, { items: utilPager.getPageItems(recipes, page, _this.RecipesPerPage), renderItem: function (recipe, index) {
                        return _this.renderPagerItem(recipe, index, shouldDisplayInputIcon);
                    }, className: "context-menu-fixed-pager-content" }, teasedRecipe),
                React.createElement("div", { className: "flex flex--guts context-menu-fixed-pager-arrow " + (page === lastPage ? "disabled" : "") },
                    React.createElement(ButtonPagerRight, { onClick: function () { return changePage(page + 1); }, disabled: page === lastPage }))));
        };
        _this.renderPagerItem = function (recipe, index, shouldDisplayInputIcon, onSelect) {
            var playerLevel = _this.props.playerLevel;
            var selectedIdx = _this.state.recipe ? _this.state.recipe.recipe.id : -1;
            var className = _this.getRecipeClassname(recipe, playerLevel, selectedIdx);
            var isRecipeLocked = !utilRecipes.isPlayerQualifiedToProduceWithRecipe(recipe, playerLevel);
            var unlockLevel = isRecipeLocked
                ? recipe.recipe.requLevel
                : undefined;
            var onClick = function () {
                if (utilRecipes.isPlayerQualifiedToProduceWithRecipe(recipe, playerLevel)) {
                    _this.onRecipeChange(recipe);
                    var building = _this.props.building;
                    var recipeId = recipe.recipe.id;
                    var finalRecipeId = recipeId - utilBuildings.getPreviousProtoStage(building);
                    utilProduction.setProductionRecipe(finalRecipeId, building.proto.typeId);
                    if (onSelect != undefined) {
                        onSelect();
                    }
                }
            };
            return (React.createElement("div", { id: "recipe_" + recipe.recipe.id, key: (recipe.recipe.id || index).toString() },
                React.createElement(Recipe, __assign({ className: "flex flex--guts " + className, onClick: onClick, shouldDisplayInputIcon: shouldDisplayInputIcon }, recipe, { unlockLevel: unlockLevel }))));
        };
        _this.filterFeasibleRecipes = function (recipes, inventoryItems) {
            return recipes.filter(function (recipe) {
                if (!recipe.recipe.useableIfFeasible) {
                    return true;
                }
                var itemInInventory = inventoryItems.find(function (item) { return item.typeId === recipe.cost[0].id; });
                return (itemInInventory !== undefined &&
                    itemInInventory.amount !== undefined &&
                    itemInInventory.amount.greaterThan(Long.ZERO));
            });
        };
        _this.getRecipeClassname = function (recipe, playerLevel, selectedIdx) {
            if (recipe.recipe.id === selectedIdx) {
                return IdStyles.StateSelected;
            }
            return "";
        };
        _this.getProductionTime = function (recipe) {
            if (!recipe || recipe.recipe.ignoreProductionTime) {
                return 0;
            }
            var currentAmount = _this.getCurrentRecipeAmount();
            return (recipe.recipe.productionTime || 0) * currentAmount;
        };
        _this.renderCosts = function (recipe) {
            var currentAmount = _this.getCurrentRecipeAmount();
            if (recipe == undefined || currentAmount <= 0) {
                return [];
            }
            return recipe.cost
                .filter(function (val) { return val.amount.greaterThan(0) || val.id === IdResource.Money; })
                .map(function (val, index) {
                var resourceProps = __assign({}, val, { amount: val.amount.multiply(currentAmount) });
                var style = {
                    gridColumnStart: _this.GridColumnEndForCost - index,
                    gridRowStart: 1,
                    msGridColumn: _this.GridColumnEndForCost - index,
                    msGridRow: 1,
                };
                return (React.createElement("div", { style: style, key: val.id, className: "flex flex--guts" },
                    React.createElement(ResourceCost, __assign({}, resourceProps))));
            });
        };
        _this.getProducts = function (recipe) {
            var currentAmount = _this.getCurrentRecipeAmount();
            if (!recipe || currentAmount <= 0) {
                return [];
            }
            var _a = _this.props, getProductTotalBuffAmount = _a.getProductTotalBuffAmount, getProductionXpBuffAmount = _a.getProductionXpBuffAmount;
            var products = recipe.product.map(function (val, index) {
                var buffProductAmount = getProductTotalBuffAmount(val.id, val.amount.multiply(currentAmount), Long.ZERO);
                var resourceProps = __assign({}, val, { amount: val.amount.multiply(currentAmount), buffAmount: buffProductAmount });
                var gridPositionStyle = {
                    gridColumnStart: _this.GridColumnStartForProduct + index,
                    gridRowStart: 1,
                    msGridColumn: _this.GridColumnStartForProduct + index,
                    msGridRow: 1,
                };
                return (React.createElement("div", { style: gridPositionStyle, key: val.id, className: "flex flex--guts" },
                    React.createElement(ResourceProduct, __assign({}, resourceProps))));
            });
            if (recipe.recipe.xp != undefined) {
                var xpProps = __assign({}, recipe.recipe.xp, { amount: recipe.recipe.xp.amount * currentAmount });
                var buffXpAmount = getProductionXpBuffAmount(xpProps.amount);
                var xpResourceProps = {
                    xpBuffAmount: Long.fromValue(buffXpAmount),
                    xpType: xpProps,
                };
                var xpStyle = {
                    gridColumnStart: _this.GridColumnStartForProduct + products.length,
                    gridRowStart: 1,
                    msGridColumn: _this.GridColumnStartForProduct + products.length,
                    msGridRow: 1,
                };
                products.push(React.createElement("div", { style: xpStyle, key: 99999, className: "flex flex--guts" },
                    React.createElement(XpResource, __assign({}, xpResourceProps))));
            }
            return products;
        };
        _this.getCurrentRecipeAmount = function () {
            var _a = _this.state, amount = _a.amount, recipe = _a.recipe;
            // User has already selected amount needed
            if (amount !== -1) {
                return amount;
            }
            if (!recipe) {
                return 1;
            }
            var maxAmount = utilRecipes.getMaxRecipeAmount(_this.state.recipe);
            var maxProducibleAmount = recipe.cost.reduce(function (acc, val) {
                var existingAmount = _this.getResourceAmountInInventory(val.id);
                if (val.amount.equals(Long.ZERO)) {
                    return acc;
                }
                // Casting as int doesn't lose any precision in this context
                var producibleAmount = existingAmount.divide(val.amount).toInt();
                return Math.min(producibleAmount, acc);
            }, maxAmount);
            return utilNumber.clamp(maxProducibleAmount, 1, maxAmount);
        };
        _this.getResourceAmountInInventory = function (typeId) {
            var inventoryResource = _this.props.resources.find(function (val) { return val.typeId === typeId; });
            return inventoryResource ? inventoryResource.amount : Long.ZERO;
        };
        _this.onCountChange = function (value) {
            _this.setState(__assign({}, _this.state, { amount: value }));
        };
        _this.onRecipeChange = function (recipeData, resetPage) {
            if (resetPage === void 0) { resetPage = false; }
            var onRecipeSelect = _this.props.onRecipeSelect;
            _this.setState(__assign({}, _this.state, { recipe: recipeData }));
            if (onRecipeSelect) {
                onRecipeSelect(recipeData.recipe.id, _this.props.building);
            }
            if (resetPage) {
                _this.forceUpdate();
            }
        };
        _this.getMenuContent = function (props) {
            var recipes = _this.filterFeasibleRecipes(props.recipes || [], props.resources);
            var buildingTypeId = props.building.proto.typeId;
            var stage = utilBuildings.getPreviousProtoStage(props.building);
            var idx = selectLastRecipeId(buildingTypeId) + stage;
            var foundRecipe = recipes.find(function (recipe) { return recipe.recipe.id === idx; }) || recipes[0];
            _this.onRecipeChange(foundRecipe, true);
        };
        return _this;
    }
    ContextMenuStartProduction.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.building.proto.typeId !== this.props.building.proto.typeId) {
            this.getMenuContent(this.props);
        }
    };
    ContextMenuStartProduction.prototype.componentDidMount = function () {
        this.getMenuContent(this.props);
    };
    ContextMenuStartProduction.prototype.render = function () {
        if (this.props.recipes == undefined) {
            return React.createElement(React.Fragment, null);
        }
        var recipe = this.state.recipe;
        var _a = this.props, building = _a.building, onStartProduction = _a.onStartProduction;
        var maxRecipeAmount = utilRecipes.getMaxRecipeAmount(this.state.recipe);
        var currentAmount = this.getCurrentRecipeAmount();
        var slider = maxRecipeAmount > 1 && (React.createElement("div", { className: "context-menu-fixed-amount-slider flex flex--guts" },
            React.createElement(Slider, { minValue: 1, maxValue: maxRecipeAmount, value: currentAmount, step: 1, onSliderChange: this.onCountChange })));
        var pager = this.getPager(recipe);
        var costs = this.renderCosts(recipe);
        var products = this.getProducts(recipe);
        var productionTime = this.getProductionTime(recipe);
        var title = this.getTitle(recipe);
        var startIcon = utilBuildings.isAcre(building) ? IdIcon.SowIcn : IdIcon.ProductionIcn;
        var productIds;
        if (recipe) {
            productIds = recipe.product.map(function (productInfo) { return productInfo.id; });
        }
        return (React.createElement("div", { className: IdStyles.ContextMenuProductionBuilding + " context-menu-fixed-container" },
            React.createElement("div", { className: IdStyles.TextButtonHeading + " flex flex--guts context-menu-fixed-title" }, title),
            React.createElement("div", { className: "context-menu-fixed-product-strip" },
                React.createElement("div", { className: IdStyles.ContextMenuBackground + " context-menu-fixed-product-strip-recipe" },
                    costs,
                    React.createElement(ProductionTime, { time: productionTime }),
                    products),
                React.createElement("div", { className: "context-menu-fixed-start-btn flex flex--end" },
                    React.createElement("div", { id: "button_start_production" },
                        React.createElement(ButtonContextMenuStart, { onClick: function () {
                                return onStartProduction(currentAmount, building.proto.id, recipe.recipe.id, productIds);
                            }, soundId: IdEventSoundCore.None },
                            React.createElement("div", { className: "flex flex--guts w100 h100" },
                                React.createElement(Icon, { icon: startIcon, styleId: IdStyles.IconLarge })))))),
            slider,
            pager));
    };
    return ContextMenuStartProduction;
}(React.PureComponent));
var mapState = function (state) { return ({
    getProductTotalBuffAmount: function (productId, amount, multiplier) {
        return selectProductionResourceTotalBuffAmount(state, productId, amount, multiplier);
    },
    getProductionXpBuffAmount: function (amount) { return selectProductionXpBuffAmount(state, amount); },
    maxStorage: selectStorageInfo(state),
    playerLevel: selectPlayerLevel(state),
    recipes: selectAllRecipeInfoByBuildingId(state, state.playerBase.buildings.building.proto.id),
    resources: state.inventoryInfo.resource,
}); };
var mapDispatch = function (dispatch) { return ({
    onRecipeSelect: function (recipeId) { return dispatch(actionProductionRecipeSelect(recipeId)); },
    onStartProduction: function (amount, buildingId, recipeId, resourceIds) {
        dispatch(actionBuildingsDeselect());
        dispatch(actionProductionStart(amount, buildingId, recipeId, resourceIds));
    },
}); };
export var ContextMenuStartProductionDOM = connect(mapState, mapDispatch)(ContextMenuStartProduction);



//////////////////
// WEBPACK FOOTER
// ./src/features/context-menu/ContextMenuStartProductionDOM.tsx
// module id = 2250
// module chunks = 3